import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import { AccordionStyled } from "assets/css/globle";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UncheckIcon from "assets/svgIcons/UncheckIcon";
import { useTranslation } from "react-i18next";

import {
  Heading,
  ActionWrapper,
  TabContainer,
} from "pages/Admin/SiteSettings/SettingStyled";
import { useSelector } from "react-redux";
import {
  ADMIN_SITE_CONFIG,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { Button, Tooltip } from "@mui/material";
import _ from "lodash";
import { HoleLocationTable } from "./HoleLocationStyled";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

const HoleDataSettings = () => {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { siteSettingsData, siteSetupData } = useSelector((state) => state.commonReducers) || [];
  const { isHoleDataModified } = useHookstate(ADMIN_SITE_CONFIG);

  const [hdSelectedCourse, setHdSelectedCourseNumber] = useState(1);
  const [coursesList, setCoursesList] = useState([]);
  const [allHandicaps, setAllHandicaps] = useState([]);
  const [finalHandicaps, setFinalHandicaps] = useState([]);
  const [allHandicapLs, setAllHandicapLs] = useState([]);
  const [finalHandicapLs, setFinalHandicapLs] = useState([]);
  const [holeDataArray, setHoleDataArray] = useState(null);
  const [originalHoleDataArray, setOriginalHoleDataArray] = useState(null);
  const [isHDModified, setIsHDModified] = useState(false);
  const [reloadState, setReloadState] = useState(true);

  useEffect(() => {
    readyForData();
  }, [siteSettingsData, siteId.get()]);

  useEffect(() => {
    setHdSelectedCourseNumber(1);
  }, [siteId.get()]);

  useEffect(() => {
    if (reloadState && siteSetupData && Object.keys(siteSetupData).length > 0) {
      setHoleDataArray(siteSetupData?.HoleDatas);
      setReloadState(false);
    }
    setOriginalHoleDataArray(siteSetupData?.HoleDatas);
  }, [siteSetupData]);

  useEffect(() => {
    if (!reloadState) {
      setReloadState(true);
    }
  }, [siteId.get()]);

  useEffect(() => {
    let finalArray = _.filter(allHandicaps, function (item) {
      return item.courseNum === hdSelectedCourse;
    });
    setFinalHandicaps(finalArray);
  }, [allHandicaps]);

  useEffect(() => {
    let finalArray = _.filter(allHandicapLs, function (item) {
      return item.courseNum === hdSelectedCourse;
    });
    setFinalHandicapLs(finalArray);
  }, [allHandicapLs]);

  let defaultCourseColors = {
    Course1: "947550",
    Course2: "002cff",
    Course3: "007a77",
    Course4: "a300db",
    Default: "666666",
  };

  const getDefaultCourseColors = (crsNum) => {
    switch (crsNum) {
      case 1:
        return defaultCourseColors.Course1;
      case 2:
        return defaultCourseColors.Course2;
      case 3:
        return defaultCourseColors.Course3;
      case 4:
        return defaultCourseColors.Course4;
      default:
        return defaultCourseColors.Default;
    }
  };

  function convRGBToInt(s) {
    var r = 0;
    if (s) {
      var h = parseInt("0xFF" + s + "L");
      r = -1 & h;
    }
    return r;
  }

  function readyForData() {
    // populate the observable coursesList array based on current site settings
    let tempCourseList = [];

    siteSettingsData &&
      siteSettingsData?.Courses?.forEach(function (crs) {
        tempCourseList.push({
          Name: crs?.Name,
          Number: crs?.Number,
          HoleCount: crs?.HoleCount,
          ColorRGB: crs?.ColorRGB
            ? crs?.ColorRGB
            : convRGBToInt(getDefaultCourseColors(crs?.Number)),
          EzLocatorCourseId: crs?.EzLocatorCourseId
            ? crs?.EzLocatorCourseId
            : "",
          Id: crs?.Id,
          ShowTeeNameOnVDU: crs?.ShowTeeNameOnVDU,
          ShowTeeColorOnVDU: crs?.ShowTeeColorOnVDU
        });
      });

    setCoursesList(tempCourseList);

    // then populate the observable Handicap arrays
    let tempArray = [];
    tempCourseList.forEach(function (crs) {
      for (let i = 0; i <= crs.HoleCount; i++) {
        let datum = {
          name: i === 0 ? "-" : i.toString(),
          value: i,
          courseNum: crs.Number,
        };
        tempArray.push(datum);
      }
    });
    setAllHandicaps(tempArray);
    setAllHandicapLs(tempArray);
  }

  function showHDAsActive(course) {
    return course.Number === hdSelectedCourse;
  }

  function setHDSelectedCourse(course) {
    setHdSelectedCourseNumber(course?.Number);
  }

  const handlefilteredHoleDataChange = (evt, idx, conditionName, hd) => {
    setIsHDModified(true);
    isHoleDataModified.set(true);
    let tempHoleDataArray = JSON.parse(JSON.stringify(holeDataArray));

    if (conditionName === "Par") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).Par = Number(evt.target.value);

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "Handicap") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).Handicap = Number(evt.target.value);

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "ParL") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).ParL = Number(evt.target.value);

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "HandicapLadies") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).HandicapL = Number(evt.target.value);

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "ApproachViewYards") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).ApproachViewYards = evt.target.value.replace(/\D/g, "");

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "StartTimeTee") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).StartTimeTee = evt.target.value.replace(/\D/g, "");

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "StartTimeFairway") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).StartTimeFairway = evt.target.value.replace(/\D/g, "");

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "StartAfterTee") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).StartAfterTee = !_.find(tempHoleDataArray, {
        Id: hd.Id,
      }).StartAfterTee;

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "IsStartHole") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).IsStartHole = !_.find(tempHoleDataArray, {
        Id: hd.Id,
      }).IsStartHole;

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "IsTurnHole") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).IsTurnHole = !_.find(tempHoleDataArray, {
        Id: hd.Id,
      }).IsTurnHole;

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "MinHoleTimeMinutes") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).MinHoleTimeMinutes = evt.target.value.replace(/\D/g, "");

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "BlindShotHole") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).BlindShotHole = !_.find(tempHoleDataArray, {
        Id: hd.Id,
      }).BlindShotHole;

      setHoleDataArray(tempHoleDataArray);
    } else if (conditionName === "BlindShotYardsFromCog") {
      _.find(tempHoleDataArray, {
        Id: hd.Id,
      }).BlindShotYardsFromCog = evt.target.value.replace(/\D/g, "");

      setHoleDataArray(tempHoleDataArray);
    } else {
      return tempHoleDataArray;
    }
  };

  const handleSave = () => {
    isHoleDataModified.set(true);
    let changedHDs = _.filter(holeDataArray, function (hd) {
      let originalHD = _.find(originalHoleDataArray, { Id: hd.Id });
      return !_.isEqual(hd, originalHD);
    });
    if (changedHDs.length) {
      changedHDs.forEach(function (hd) {
        dispatch(COMMON_SERVICES.putHoleDataService(hd, siteId.get())).then(() => {
          setIsHDModified(false);
          dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
        });
      });
    }
  };

  return (
    <AccordionStyled>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Heading>
            <h3>{t("Hole_Data_Settings")}</h3>
          </Heading>
        </AccordionSummary>
        <AccordionDetails>
          <TabContainer className="tab-container">
            <div className="header-btn-wrapper">
              {coursesList && coursesList.length > 1 ? (
                <div className="tab-btn-wrapper">
                  {coursesList?.map((course, index) => {
                    return (
                      <Button
                        className={showHDAsActive(course) ? "active" : ""}
                        onClick={() => setHDSelectedCourse(course)}
                        key={`${course.Name}_${index}`}
                      >
                        {course?.Name}
                      </Button>
                    );
                  })}
                </div>
              ) : (
                <></>
              )}

              <ActionWrapper>
                <Tooltip title="Cancel hole data changes">
                  <Button
                    disabled={!isHDModified}
                    onClick={() => {
                      setHoleDataArray(originalHoleDataArray);
                      setIsHDModified(false);
                      isHoleDataModified(false);
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                </Tooltip>
                <Tooltip title="Save hole data changes">
                  <Button
                    disabled={!isHDModified}
                    className={isHDModified ? "active" : ""}
                    onClick={handleSave}
                  >
                    {t("Save")}
                  </Button>
                </Tooltip>
              </ActionWrapper>
            </div>
            <HoleLocationTable>
              <table>
                <tr>
                  <th>{t("Hole")}</th>
                  <th>Par</th>
                  <th>HCP</th>
                  <th>Ladies par</th>
                  <th>LHCP</th>
                  <th>Appr yds</th>
                  <th>Tee start (s)</th>
                  <th>Fairway start (s)</th>
                  <th>Start after tee</th>
                  <th>Is start hole</th>
                  <th>Is turn hole</th>
                  <th>Min time (m)</th>
                  <th>Is blind shot hole</th>
                  <th>Monitor yds from CoG</th>
                </tr>

                {holeDataArray && holeDataArray.length > 0 ? (
                  <>
                    {holeDataArray
                      ?.filter((hd) => hd.Course === hdSelectedCourse)
                      ?.map((hd, index) => {
                        return (
                          <tr key={hd?.Id}>
                            <td>{hd?.Hole}</td>
                            <td>
                              <Tooltip title="Men's par">
                                <select
                                  value={hd?.Par}
                                  onChange={(e) =>
                                    handlefilteredHoleDataChange(
                                      e,
                                      index,
                                      "Par",
                                      hd
                                    )
                                  }
                                >
                                  <option value={3}>3</option>
                                  <option value={4}>4</option>
                                  <option value={5}>5</option>
                                  <option value={6}>6</option>
                                </select>
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Men's handicap">
                                <select
                                  value={hd?.Handicap}
                                  onChange={(e) =>
                                    handlefilteredHoleDataChange(
                                      e,
                                      index,
                                      "Handicap",
                                      hd
                                    )
                                  }
                                >
                                  {finalHandicaps &&
                                    finalHandicaps.length > 0 ? (
                                    <>
                                      {finalHandicaps?.map((el, index) => {
                                        return (
                                          <option
                                            value={el.value}
                                            key={`${el.name}_${index}`}
                                          >
                                            {el.name}
                                          </option>
                                        );
                                      })}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </select>
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Ladies par">
                                <select
                                  value={hd?.ParL}
                                  onChange={(e) =>
                                    handlefilteredHoleDataChange(
                                      e,
                                      index,
                                      "ParL",
                                      hd
                                    )
                                  }
                                >
                                  <option value={0}>-</option>
                                  <option value={3}>3</option>
                                  <option value={4}>4</option>
                                  <option value={5}>5</option>
                                  <option value={6}>6</option>
                                </select>
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Ladies handicap">
                                <select
                                  value={hd?.HandicapL}
                                  onChange={(e) =>
                                    handlefilteredHoleDataChange(
                                      e,
                                      index,
                                      "HandicapLadies",
                                      hd
                                    )
                                  }
                                >
                                  {finalHandicapLs &&
                                    finalHandicapLs.length > 0 ? (
                                    <>
                                      {finalHandicapLs?.map((el, index) => {
                                        return (
                                          <option
                                            value={el.value}
                                            key={`finalHandicapLs_${el.name}_${index}`}
                                          >
                                            {el.name}
                                          </option>
                                        );
                                      })}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </select>
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Approach view (yards)">
                                <input
                                  className="input-field"
                                  type="text"
                                  value={hd?.ApproachViewYards}
                                  maxLength={4}
                                  onChange={(e) =>
                                    handlefilteredHoleDataChange(
                                      e,
                                      index,
                                      "ApproachViewYards",
                                      hd
                                    )
                                  }
                                />
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Start time tee">
                                <input
                                  className="input-field"
                                  type="text"
                                  value={hd?.StartTimeTee}
                                  maxLength={4}
                                  onChange={(e) =>
                                    handlefilteredHoleDataChange(
                                      e,
                                      index,
                                      "StartTimeTee",
                                      hd
                                    )
                                  }
                                />
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Start time fairway">
                                <input
                                  className="input-field"
                                  type="text"
                                  value={hd?.StartTimeFairway}
                                  maxLength={4}
                                  onChange={(e) =>
                                    handlefilteredHoleDataChange(
                                      e,
                                      index,
                                      "StartTimeFairway",
                                      hd
                                    )
                                  }
                                />
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Start after tee">
                                <div className="checkbox-wrapper">
                                  <Checkbox
                                    checked={hd?.StartAfterTee}
                                    icon={<UncheckIcon />}
                                    checkedIcon={<CheckIcon />}
                                    width={15}
                                    height={15}
                                    onChange={(e) =>
                                      handlefilteredHoleDataChange(
                                        e,
                                        index,
                                        "StartAfterTee",
                                        hd
                                      )
                                    }
                                  />
                                </div>
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Is a start hole">
                                <div className="checkbox-wrapper">
                                  <Checkbox
                                    checked={hd?.IsStartHole}
                                    icon={<UncheckIcon />}
                                    checkedIcon={<CheckIcon />}
                                    width={15}
                                    height={15}
                                    onChange={(e) =>
                                      handlefilteredHoleDataChange(
                                        e,
                                        index,
                                        "IsStartHole",
                                        hd
                                      )
                                    }
                                  />
                                </div>
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Is a turn hole">
                                <div className="checkbox-wrapper">
                                  <Checkbox
                                    checked={hd?.IsTurnHole}
                                    icon={<UncheckIcon />}
                                    checkedIcon={<CheckIcon />}
                                    width={15}
                                    height={15}
                                    onChange={(e) =>
                                      handlefilteredHoleDataChange(
                                        e,
                                        index,
                                        "IsTurnHole",
                                        hd
                                      )
                                    }
                                  />
                                </div>
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Min hole time (min)">
                                <input
                                  className="input-field"
                                  type="text"
                                  value={hd?.MinHoleTimeMinutes}
                                  maxLength={4}
                                  onChange={(e) =>
                                    handlefilteredHoleDataChange(
                                      e,
                                      index,
                                      "MinHoleTimeMinutes",
                                      hd
                                    )
                                  }
                                />
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Is a blind hole">
                                <div>
                                  <Checkbox
                                    checked={hd?.BlindShotHole}
                                    icon={<UncheckIcon />}
                                    checkedIcon={<CheckIcon />}
                                    width={15}
                                    height={15}
                                    onChange={(e) =>
                                      handlefilteredHoleDataChange(
                                        e,
                                        index,
                                        "BlindShotHole",
                                        hd
                                      )
                                    }
                                  />
                                </div>
                              </Tooltip>
                            </td>
                            <td>
                              <Tooltip title="Monitor until x yds from CoG">
                                <input
                                  className="input-field"
                                  type="text"
                                  value={hd?.BlindShotYardsFromCog}
                                  maxLength={4}
                                  onChange={(e) =>
                                    handlefilteredHoleDataChange(
                                      e,
                                      index,
                                      "BlindShotYardsFromCog",
                                      hd
                                    )
                                  }
                                />
                              </Tooltip>
                            </td>
                          </tr>
                        );
                      })}
                  </>
                ) : (
                  <></>
                )}
              </table>
            </HoleLocationTable>
          </TabContainer>
        </AccordionDetails>
      </Accordion>
    </AccordionStyled>
  );
};

export default HoleDataSettings;
